import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { TimeScanningService } from "../../../shared/data.service";
import { UserService } from "../../../../../../shared";
import { HallPassInsertRequest } from "../../../shared/HallPassInsertRequest";
import * as moment from "moment";

@Component({
	selector: "app-scan-point-manual-add-hall-pass",
	templateUrl: "./scan-point-manual-add-hall-pass.component.html",
	styleUrls: ["./scan-point-manual-add-hall-pass.component.css"],
})
export class ScanPointManualAddHallPassComponent implements OnInit {
	constructor(
		public ref: DynamicDialogRef,
		private dialogConfig: DynamicDialogConfig,
		private scanService: TimeScanningService,
		private confirmationService: ConfirmationService,
		private userService: UserService
	) {}

	ngOnInit(): void {
		// console.log("Add Hall Pass");
		// console.log(this.dialogConfig.data);

		this.user = this.userService.getCurrentUser();

		this.PersonID = this.dialogConfig.data.PersonID;
		this.PersonName = this.dialogConfig.data.PersonName;
		this.DesignatorID = this.dialogConfig.data.DesignatorID;

		this.FacilityID = this.dialogConfig.data.SelectedFacilityID;
		this.FacilityLocationID = this.dialogConfig.data.SelectedFacilityLocationID;
		this.SelectedPrinterID = this.dialogConfig.data.SelectedPrinterID;

		this.loadHallpassReasonList();
		this.loadClassAttendanceExcuseList();
		this.loadToFacilityList();
	}

	//////////////////////////////////////////
	// Data
	//////////////////////////////////////////

	//From Parent
	PersonID: any;
	PersonName: string = "";
	DesignatorID: string = "";
	FacilityID: any;
	FacilityLocationID: any;
	SelectedPrinterID: any;

	user: any;

	SelectedHallPassReason: any;
	lstHallPassReason: any = [];

	SelectedExcuse: any;
	lstExcuse: any = [];

	FromLocationDesc: string = "";

	SelectedLocation: any;
	lstLocation: any = [];

	PassDurationMinutes: number = 15;
	Comments: string = "";

	errorMessage: any = "";

	ReasonLoading: boolean = true;
	ExcuseLoading: boolean = true;
	FacilityLocationLoading: boolean = true;
	Processing: boolean = false;

	//////////////////////////////////////////

	//////////////////////////////////////////
	// Load Data
	//////////////////////////////////////////

	loadHallpassReasonList() {
		this.ReasonLoading = true;

		var result = this.scanService.loadHallpassReasonList("", this.FacilityID);
		result.subscribe(
			(response) => {
				this.ReasonLoading = false;

				this.lstHallPassReason = response;

				if (this.lstHallPassReason.length > 0) {
					this.SelectedHallPassReason = this.lstHallPassReason[0];
				} else {
					this.SelectedHallPassReason = null;
				}
			},
			(error) => {
				this.ReasonLoading = false;
			}
		);
	}

	loadClassAttendanceExcuseList() {
		this.ExcuseLoading = true;

		var result = this.scanService.loadClassAttendanceExcuseSelectList(this.FacilityID);
		result.subscribe(
			(response) => {
				this.ExcuseLoading = false;

				this.lstExcuse = response;

				if (this.lstExcuse.length > 0) {
					this.SelectedExcuse = this.lstExcuse[0];
				} else {
					this.SelectedExcuse = null;
				}
			},
			(error) => {
				this.ExcuseLoading = false;
			}
		);
	}

	loadToFacilityList() {
		this.FacilityLocationLoading = true;

		var result = this.scanService.loadFacilityLocationList("", this.FacilityID);
		result.subscribe(
			(response) => {
				this.FacilityLocationLoading = false;

				this.lstLocation = response;

				if (this.lstLocation.length > 0) {
					this.SelectedLocation = this.lstLocation[0];
				}

				//Set From Location
				for (var i = 0; i < this.lstLocation.length; i++) {
					if (this.lstLocation[i].FacilityLocationID == this.FacilityLocationID) {
						this.FromLocationDesc = this.lstLocation[i].FacilityLocationName;
						break;
					}
				}
			},
			(error) => {
				this.FacilityLocationLoading = false;
			}
		);
	}

	//////////////////////////////////////////

	//////////////////////////////////////////
	// Buttons
	//////////////////////////////////////////
	onAdd() {
		//Error Handling
		if (this.IsNotQuick()) {
			if (this.SelectedLocation.FacilityLocationID == this.FacilityLocationID) {
				this.errorMessage = "Hall Pass is from and to the same location";
				return;
			}

			try {
				var num = Number(this.PassDurationMinutes);
				if (Number.isNaN(num)) {
					this.errorMessage = "Invalid Pass Duration";
					return;
				}
			} catch (e) {
				this.errorMessage = "Invalid Pass Duration";
				return;
			}

			this.NotQuickAdd();
		} else {
			this.SimpleAdd();
		}
	}

	SimpleAdd() {
		// console.log("Quick Add");

		this.Processing = true;

		var DefaultDur: any = 15;
		if (this.SelectedHallPassReason.DefaultDurationMinutes != null) {
			DefaultDur = this.SelectedHallPassReason.DefaultDurationMinutes;
		}

		let EndTime = new Date();
		EndTime.setMinutes(EndTime.getMinutes() + DefaultDur);

		let parms: HallPassInsertRequest = {
			ScheduleID: -1,
			HallpassReasonID: this.SelectedHallPassReason.HallpassReasonID,
			PersonID: this.PersonID,
			DayID: -1,
			From_FacilityLocationID: this.FacilityLocationID,
			To_FacilityLocationID: -1,
			GroupActionID: -1,
			FromLocationDesc: this.FromLocationDesc,
			ToLocationDesc: "",
			HallpassDate: moment(new Date()).format("MM/DD/YYYY HH:mm:00 a"),
			DurationMinutes: DefaultDur,
			StartTime: moment(new Date()).format("MM/DD/YYYY HH:mm:00 a"),
			CloseTime: "", //moment(EndTime).format("MM/DD/YYYY HH:mm:00 a"),
			Comment: this.Comments,
			Active: 1,
			IDPrinterID: this.SelectedPrinterID,
			ClassAttendanceExcuseID: -1,
			c_PersonID: this.user.personID,
		};

		var result = this.scanService.HallPassInsert(parms);
		result.subscribe(
			(response) => {
				this.Processing = false;

				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "addhallpass",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Hall Pass was added successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "addhallpass",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not Create the Hall Pass",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	NotQuickAdd() {
		// console.log("Long Add");

		let EndTime = new Date();
		EndTime.setMinutes(EndTime.getMinutes() + Number(this.PassDurationMinutes));

		this.Processing = true;

		let parms: HallPassInsertRequest = {
			ScheduleID: -1,
			HallpassReasonID: this.SelectedHallPassReason.HallpassReasonID,
			PersonID: this.PersonID,
			DayID: -1,
			From_FacilityLocationID: this.FacilityLocationID,
			To_FacilityLocationID: this.SelectedLocation.FacilityLocationID,
			GroupActionID: -1,
			FromLocationDesc: this.FromLocationDesc,
			ToLocationDesc: this.SelectedLocation.FacilityLocationName,
			HallpassDate: moment(new Date()).format("MM/DD/YYYY HH:mm:00 a"),
			DurationMinutes: this.PassDurationMinutes,
			StartTime: moment(new Date()).format("MM/DD/YYYY HH:mm:00 a"),
			CloseTime: "", //moment(EndTime).format("MM/DD/YYYY HH:mm:00 a"), //Close time set manually?
			Comment: this.Comments,
			Active: 1,
			IDPrinterID: this.SelectedPrinterID,
			ClassAttendanceExcuseID: this.SelectedExcuse.ClassAttendanceExcuseID,
			c_PersonID: this.user.personID,
		};

		var result = this.scanService.HallPassInsert(parms);
		result.subscribe(
			(response) => {
				this.Processing = false;

				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "addhallpass",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Hall Pass was added successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "addhallpass",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not Create the Hall Pass",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	//////////////////////////////////////////

	//////////////////////////////////////////
	// Events
	//////////////////////////////////////////

	//////////////////////////////////////////

	//////////////////////////////////////////
	// Helpers
	//////////////////////////////////////////

	IsLoading() {
		return this.Processing == true || this.ReasonLoading == true || this.ExcuseLoading == true || this.FacilityLocationLoading == true;
	}

	IsNotQuick() {
		if (this.SelectedHallPassReason == null) {
			return false;
		} else {
			return this.SelectedHallPassReason.IsQuick == 0;
		}
	}

	//////////////////////////////////////////
}
